import { render, staticRenderFns } from "./Link.vue?vue&type=template&id=cc549bca&scoped=true&lang=html&"
import script from "./Link.vue?vue&type=script&lang=coffee&"
export * from "./Link.vue?vue&type=script&lang=coffee&"
import style0 from "./Link.vue?vue&type=style&index=0&id=cc549bca&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc549bca",
  null
  
)

component.options.__file = "Link.vue"
export default component.exports